var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconServices5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    clipPath: "url(#clip0_205_512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M29.03 57.31C44.6486 57.31 57.31 44.6486 57.31 29.03C57.31 13.4114 44.6486 0.75 29.03 0.75C13.4114 0.75 0.75 13.4114 0.75 29.03C0.75 44.6486 13.4114 57.31 29.03 57.31Z",
    fill: "white",
    stroke: "#8CC63F",
    strokeWidth: 1.5,
    strokeMiterlimit: 22.93
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.7098 24.96C32.7298 26.23 31.1298 27.28 29.1498 27.3C27.1698 27.33 25.5398 26.32 25.5298 25.05L25.3498 10.68C25.3298 9.41001 26.9298 8.36001 28.9198 8.34001C30.9098 8.31001 32.5298 9.32001 32.5398 10.59L32.7198 24.96H32.7098Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.1299 12.3899C38.7899 11.4199 36.9499 11.3399 35.4999 12.3199C33.6599 13.5699 33.1799 16.0799 34.4299 17.9199C34.7999 18.4699 35.2899 18.8999 35.8399 19.1999C35.8399 19.1999 35.8399 19.2099 35.8299 19.2199C37.2199 20.1099 38.4499 21.2899 39.4399 22.7399C43.3399 28.4899 41.8399 36.3099 36.0899 40.2099C30.3399 44.1099 22.5199 42.6099 18.6199 36.8599C14.7899 31.2199 16.1699 23.5799 21.6599 19.6099C21.7599 19.5499 21.8699 19.4899 21.9699 19.4199C23.8199 18.1699 24.2999 15.6499 23.0499 13.7999C21.7899 11.9499 19.2799 11.4699 17.4299 12.7199C17.3299 12.7899 17.2399 12.8599 17.1399 12.9399C7.95993 19.3999 5.61993 32.0599 11.9499 41.3899C18.3499 50.8299 31.1899 53.2899 40.6299 46.8899C50.0699 40.4899 52.5299 27.6499 46.1299 18.2099C44.4999 15.7999 42.4499 13.8599 40.1399 12.3899",
    fill: "#8CC63F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58.05,
    height: 58.05,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServices5);
export default __webpack_public_path__ + "static/media/icon-services-5.6a7bf374a93106cbffc359f54c831542.svg";
export { ForwardRef as ReactComponent };